import { Dispatch, SetStateAction, useEffect } from "react";
import {
  getReverifyTabs,
  isReverifyTabAPlaceholder,
  isReverifyTabArchived
} from "../utils";
import { ReverifyRequest } from "shared/types";
import { VerifiedItem } from "../../../types/verified";
import { BankStatementItem } from "../../../types/verified/bank-statment";
import { EmptyReverifyItem } from "../types";
// check-deprecations-disable-next-line -- needs horizontal scroll behaviour
import { Tabs } from "shared/components/Tabs";

interface Props {
  reverifyAttempts: (EmptyReverifyItem | VerifiedItem | BankStatementItem[])[];
  selectedReverifyAttempt?: VerifiedItem | VerifiedItem[];
  selectedReverifyAttemptIdx: number;
  setSelectedReverifyAttemptIdx: Dispatch<SetStateAction<number>>;
  setHideProjectedDebtSection: (value: boolean) => void;
  pendingReverifyRequest?: ReverifyRequest | null;
}

export const IncomeReverifyTabs = ({
  reverifyAttempts,
  selectedReverifyAttemptIdx,
  setSelectedReverifyAttemptIdx,
  setHideProjectedDebtSection,
  pendingReverifyRequest
}: Props) => {
  const { tabIds, displayMap } = getReverifyTabs(reverifyAttempts);
  const emptyTabIndex = 0;

  useEffect(() => {
    if (pendingReverifyRequest) {
      setSelectedReverifyAttemptIdx(emptyTabIndex);
      setHideProjectedDebtSection(true);
    }
  }, [pendingReverifyRequest?.id, emptyTabIndex]);

  const onTabChange = (tab: string) => {
    const idx = Number(tab);

    if (idx === emptyTabIndex) {
      setSelectedReverifyAttemptIdx(idx);
      setHideProjectedDebtSection(true);
      return;
    }

    const attempt = reverifyAttempts[idx];
    const isArchived =
      (pendingReverifyRequest && !isReverifyTabAPlaceholder(attempt)) ||
      isReverifyTabArchived(attempt);

    setSelectedReverifyAttemptIdx(idx);
    setHideProjectedDebtSection(Boolean(isArchived));
  };

  return (
    // check-deprecations-disable-next-line -- needs horizontal scroll behaviour
    <Tabs
      variant="underline"
      tabs={tabIds}
      displayMap={displayMap}
      selected={String(selectedReverifyAttemptIdx)}
      setActiveTab={onTabChange}
    />
  );
};
